require("!!/home/runner/work/banquetNinja/banquetNinja/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/banquetNinja/banquetNinja/node_modules/raw-loader/index.js!/home/runner/work/banquetNinja/banquetNinja/node_modules/ng-annotate-loader/loader.js!/home/runner/work/banquetNinja/banquetNinja/node_modules/babel-loader/index.js!/home/runner/work/banquetNinja/banquetNinja/dataNinja/angular-resource.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./dataNinja/angular-resource.js
// module id = 107
// module chunks = 0